import { useState } from 'react';

/**
 * Hook to manage loading state
 * @param defaultLoading - default loading boolean state
 * @param defaultTip - default tip string
 * @returns 
 */
const useLoading = (defaultLoading:boolean = false,defaultTip:string = '') => {
  const [loading, setLoading] = useState<boolean>(defaultLoading);
  const [loadingTip, setLoadingTip] = useState<string>(defaultTip);

  return {
    loading,
    setLoading,
    loadingTip,
    setLoadingTip,
  };
};

export default useLoading;